module.exports = __webpack_public_path__ + "img/curtains.12f58591.png";